import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PhoneCall } from 'lucide-react';
import AdminTabScroller from '@/components/admin/AdminTabScroller';
import OutreachCallsPanel from '@/components/admin/OutreachCallsPanel';
import OutreachChannelInbox from '@/components/admin/OutreachChannelInbox';

const TABS = [
  { id: 'calls', label: 'Calls', testId: 'outreach-tab-calls' },
  { id: 'sms', label: 'SMS', testId: 'outreach-tab-sms' },
  { id: 'whatsapp', label: 'WhatsApp', testId: 'outreach-tab-whatsapp' },
];

const SUBTITLES = {
  calls: 'Dograh AI voice calls — recordings, transcripts, and linked leads',
  sms: 'Customer text messages on the customer-care number',
  whatsapp: 'Customer WhatsApp messages on the customer-care number',
};

function activeTab(value) {
  return value === 'sms' || value === 'whatsapp' ? value : 'calls';
}

export default function AdminOutreachAgentPage() {
  const [params, setParams] = useSearchParams();
  const tab = activeTab(params.get('tab'));
  const threadId = tab === 'calls' ? '' : (params.get('thread') || '');

  const subtitle = SUBTITLES[tab];

  const openTab = (id) => {
    const next = new URLSearchParams(params);
    if (id === 'calls') {
      next.delete('tab');
      next.delete('thread');
    } else {
      next.set('tab', id);
      if (id !== tab) next.delete('thread');
    }
    setParams(next, { replace: true });
  };

  const selectThread = (id) => {
    const next = new URLSearchParams(params);
    next.set('tab', tab);
    if (id) next.set('thread', id);
    else next.delete('thread');
    setParams(next, { replace: true });
  };

  const tabs = useMemo(() => TABS, []);

  return (
    <div className="p-4 sm:p-6 max-w-[1500px] mx-auto" data-testid="admin-outreach-agent-page">
      <div className="mb-2">
        <h1 className="text-2xl font-['Unbounded'] font-bold text-white flex items-center gap-2">
          <PhoneCall className="w-6 h-6 text-blue-400" />
          Outreach Agent
        </h1>
        <p className="text-sm font-['Manrope'] text-white/40 mt-1">{subtitle}</p>
      </div>
      <AdminTabScroller
        tabs={tabs}
        activeId={tab}
        onChange={openTab}
        testId="outreach-tabs"
      />
      {tab === 'calls' ? (
        <OutreachCallsPanel embedded />
      ) : (
        <OutreachChannelInbox
          channel={tab}
          threadId={threadId}
          onSelectThread={selectThread}
        />
      )}
    </div>
  );
}
